import { useContext } from "react";
import { ImperativeDialogContext } from "@repo/ui";
import type { Workflow } from "~/types/api";
import {
  useWorkflowCreationContext,
  type OnAfterCreateFn,
} from "../workflow-creation-context-provider";
import { WorkflowsDialog } from "./workflows-dialog";

export const useWorkflowsDialog = () => {
  const { resetState, initializeFromWorkflow, updateState, onAfterCreate } =
    useWorkflowCreationContext();
  const dialogContext = useContext(ImperativeDialogContext);
  const { closeDialog, showDialog } = dialogContext ?? {};

  const handleDialogClose = () => {
    resetState();
    closeDialog?.();
  };

  const showWorkflowDialog = (options?: {
    sourceWorkflow?: Workflow;
    onAfterCreate?: OnAfterCreateFn;
    title?: string;
    isUpgrade?: boolean;
    contentClassName?: string;
  }) => {
    if (options?.sourceWorkflow) {
      initializeFromWorkflow(options.sourceWorkflow, options.isUpgrade);
    } else {
      resetState();
    }
    updateState("currentView", "default");
    if (options?.onAfterCreate) {
      onAfterCreate.current = options.onAfterCreate;
    }

    showDialog?.({
      content: <WorkflowsDialog onClose={handleDialogClose} customTitle={options?.title} />,
      contentClassName: options?.contentClassName ?? "max-w-4xl",
      onClose: () => {
        handleDialogClose();
      },
    });
  };

  return { showWorkflowDialog, closeDialog };
};
